import React, { FC, memo, useState } from "react";
import { ButtonColor } from "enums/Button";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button/Button";
import {
  ChevronIcon,
  Title,
  TitleRow,
  ToggleButton,
  Wrapper,
  YearList,
} from "./YearSelector.styles";

interface YearSelectorProps {
  availableYears: number[];
  selectedYear: number;
  onYearChange: (year: number) => void;
}

const YearSelector: FC<YearSelectorProps> = ({
  availableYears,
  selectedYear,
  onYearChange,
}) => {
  const { t } = useTranslation("common");
  const [isExpanded, setIsExpanded] = useState(false);

  if (availableYears.length === 0) return null;

  return (
    <Wrapper>
      <TitleRow>
        <Title>
          {t("parcels.historyForSelectedYear", { selectedYear })}
        </Title>
        <ToggleButton onClick={() => setIsExpanded((prev) => !prev)}>
          {t("common.selectYear")}
          <ChevronIcon $isOpen={isExpanded} type={IconType.Triangle} />
        </ToggleButton>
      </TitleRow>
      {isExpanded && (
        <YearList>
          {availableYears.map((year) => (
            <Button
              key={year}
              color={year === selectedYear ? ButtonColor.Primary : ButtonColor.Muted}
              onClick={() => onYearChange(year)}
            >
              {year}
            </Button>
          ))}
        </YearList>
      )}
    </Wrapper>
  );
};

export default memo(YearSelector);
